import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./LandingPage/Pages";
import KategoriPage from "./LandingPage/Pages/kategori/kategoriPages";
import DetailEditorial from "./LandingPage/Components/editorial/detaileditorial";
import PublicEditorial from "./LandingPage/Pages/publicBerita/publicBerita";
import TentangKamiPage from "./LandingPage/Pages/tentangPage/tentangkamiPage";
import AstaCitaPage from "./LandingPage/Pages/tentangPage/astacitaPage";
import TujuanProgramPage from "./LandingPage/Pages/tentangPage/tujuanPage";
import SosialMediaMerahPutih08 from "./LandingPage/Pages/sosmed/sosmed";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/tentangkami" element={<TentangKamiPage />} />
        <Route path="/astacita" element={<AstaCitaPage />} />
        <Route path="/tujuanprogram" element={<TujuanProgramPage />} />
        <Route path="/kategori/:kategori" element={<KategoriPage />} />
        <Route path="/berita/:id" element={<DetailEditorial />} />
        <Route path="/editorial/public" element={<PublicEditorial />} />
        <Route path="/sosmed" element={<SosialMediaMerahPutih08 />} />
      </Routes>
    </Router>
  );
};

export default App;
